import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';
import { visitPlayerScreen } from '../lib/player_screen_navigation.js';

// Selection is server-authorized; this controller only opens the shared dialog
// and recovers when a live permission update removes the selected workspace.
export default class extends Controller {
  static targets = ['workspace', 'trigger'];
  static values = { entryUrl: String, modalUrl: String };

  connect() {
    Turbo.cache.exemptPageFromCache();
    this.openSelection();
  }

  openSelection(event) {
    if (event?.type === 'turbo:frame-load' && !event.target.contains(this.element)) return;
    // Turbo temporarily detaches permanent frames while a new page connects.
    // The completed page/frame load calls this again after the modal is restored.
    const frame = document.getElementById('modal');
    if (this.modalUrlValue && !this.selectionOpened && frame) {
      this.selectionOpened = true;
      this.triggerTarget.focus({ preventScroll: true });
      if (frame.getAttribute('src') === this.modalUrlValue) frame.reload();
      else frame.src = this.modalUrlValue;
    }
  }

  workspaceTargetDisconnected() {
    queueMicrotask(() => {
      if (this.element.isConnected && !this.hasWorkspaceTarget) Turbo.visit(this.entryUrlValue, { action: 'replace' });
    });
  }

  returnFocus() {
    if (this.element.isConnected && this.hasTriggerTarget) this.triggerTarget.focus({ preventScroll: true });
  }

  accessLost() {
    if (this.hasWorkspaceTarget) this.workspaceTarget.remove();
  }

  claimed(event) {
    const destination = event.detail.fetchResponse?.response.headers.get('X-Player-Screen-Location');
    if (event.detail.success && destination) visitPlayerScreen(destination);
  }
}
